<!-- src/components/shop/AdminVendorLoginBanner.vue -->
<!--
  2026-10-16 관리자 대리 로그인 표시 띠.
  관리자 거래처관리 → [이 거래처로 로그인] 으로 들어온 탭에서만 보인다(sessionStorage.admin_vendor_login).
  고객이 직접 로그인한 화면에는 절대 나오지 않는다. 클래스는 avl- 접두사(전역 클래스 충돌 방지).
-->
<template>
  <div v-if="info" class="avl-bar">
    <i class="bi bi-person-badge"></i>
    <span class="avl-text">
      관리자 접속 중 : <strong>{{ info.businessName || info.name || '거래처' }}</strong>
      <span class="avl-sub">(고객 계정으로 로그인된 상태입니다. 주문·결제도 실제로 처리됩니다)</span>
    </span>
    <button class="avl-end" @click="end">접속 종료</button>
  </div>
</template>

<script>
export default {
  name: 'AdminVendorLoginBanner',
  data() {
    return { info: null };
  },
  created() {
    try {
      const raw = sessionStorage.getItem('admin_vendor_login');
      this.info = raw ? JSON.parse(raw) : null;
    } catch (e) {
      this.info = null;
    }
  },
  methods: {
    end() {
      sessionStorage.removeItem('auth_token');
      sessionStorage.removeItem('user_info');
      sessionStorage.removeItem('admin_vendor_login');
      // 관리자 화면에서 연 새 탭이면 닫히고, 안 닫히면 로그인 화면으로
      window.close();
      setTimeout(() => { window.location.replace('/login'); }, 300);
    }
  }
};
</script>

<style scoped>
.avl-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: #b91c1c;
  color: #fff;
  font-size: 14px;
  font-family: 'Noto Sans KR', sans-serif;
  position: relative;
  z-index: 3000;
}
.avl-text { flex: 1; min-width: 0; }
.avl-sub { margin-left: 6px; font-size: 12px; opacity: 0.85; }
.avl-end {
  flex-shrink: 0;
  padding: 4px 12px;
  border: 1px solid #fff;
  border-radius: 4px;
  background: transparent;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}
.avl-end:hover { background: rgba(255, 255, 255, 0.15); }
@media (max-width: 576px) {
  .avl-sub { display: none; }
}
</style>
